const breadcrumb = {
  reports: 'Rapports',
  details: 'Détails du rapport',
  unknown: 'Inconnu',
};

const button = {
  backToList: 'Retour à la liste',
  downloadReportKML: 'Télécharger le rapport KML',
  downloadReportPDF: 'Télécharger le rapport PDF',
  pdfReportTooltip: 'Le nombre maximal de détections pour générer un PDF est de 500. Appliquez plus de filtres.',
  downloadErrorReportCSV: "Télécharger le rapport d'erreur CSV",
  uploadReport: 'Charger un rapport',
  exportPatrols: 'Exporter des patrouilles',
  filterPatrols: 'Filtrer des patrouilles',
  startDate: 'Date de début',
  endDate: 'Date de fin',
  publish: 'Publier',
  pushToIRTH: 'Pousser vers IRTH',
  resyncPilot: 'Resynchroniser pilote',
};

const details = {
  airports: 'Aéroports',
  centerlines: 'Lignes de centre',
  coverage: 'Couverture',
  endDate: 'Date et heure de fin',
  flightDuration: 'Durée de vol',
  flightPath: 'Parcours du vol',
  hyspexCoverage: 'Couverture Hyspex',
  inspectionDuration: "Durée d'inspection",
  obstacles: 'Obstacles',
  pipelineCenterline: 'Ligne de centre du pipeline',
  startDate: 'Date et heure de début',
  threat: 'Menace',
  threats: 'Menaces',
  transferDate: 'Date et heure de transfert',
  uncoveredAreas: 'Zones non couvertes',
};

const table = {
  id: 'ID',
  missionLength: 'Longueur de la mission (mi)',
  coverage: 'Couverture',
  detectedThreats: 'Menaces détectées',
  downloadedBy: 'Téléchargé par',
  flightDuration: 'Durée de vol',
  inspectionDuration: "Durée d'inspection",
  missionName: 'Nom de la mission',
  patrolStartDate: 'Date de début de la patrouille',
  pilotName: 'Nom du pilote',
  pilotLicenseNumber: 'Numéro de licence du pilote',
  receivedDate: 'Date de réception',
};

const filter = {
  selectClient: 'Sélectionnez un client',
};

const finding = {
  exactFindingId: 'Id exact de la détection',
  findingNumber: 'Détection #{{number}}',
  spitfireId: 'ID de Spitfire: {{number}}',
  class: 'Classe',
  contacted: 'Contacté',
  detectionAt: 'Détection à',
  findings: 'Détections',
  latitude: 'Lat',
  longitude: 'Long',
  sent: 'Envoyée',
  type: 'Type',
  workZone: 'Zone de construction',
  hidePassengerVehicles: 'Cacher les voitures',
  hideAutomaticallyNotedThreats: 'Cacher les notes automatiques',
  irthExternalId: 'Id externe pour IRTH',
};

const message = {
  deletionConfirmation: 'Voulez-vous supprimer cette patrouille?',
  reviewConfirmation: 'Voulez-vous marquer cette patrouille comme revue?',
  reviewCompleted: 'Revue terminée',
  reviewCompletedSuccessfully: 'La revue de la patrouille a été terminée avec succès',
  published: 'Rapport publié',
  pushedToIrth: 'Rapport publié à IRTH',
  missionPilotNotFound: "Impossible d'associer une mission à un pilote existant",
};

export default {
  breadcrumb,
  button,
  deleted: 'supprimée',
  details,
  filter,
  finding,
  message,
  missionDetails: 'Mission Details',
  table,
  showrow: 'Afficher ROW',
  hiderow: 'Cacher ROW',
};
